export default "__VITE_ASSET__3d7b5e17__"